<div class="tabbable__panel panel-margin right section info clearfix">
  <div class="col-md-12 padding-left-right--2x">
    <h2>Detaljer</h2>
  </div>
</div>

<div class="tabbable__body clearfix">
  <div class="margin-bottom--2x">
    <date-span
      [start]="campaignPeriod.start"
      [end]="campaignPeriod.end"
    ></date-span>
  </div>
  <customer-agency-row [data]="campaign"></customer-agency-row>
  <h3 class="margin-top--none margin-bottom--2x">{{ campaignName }}</h3>

  <div class="divider margin-top-bottom--2x"></div>
  <ng-container *ngIf="brand" class="margin-bottom--2x">
    <p>Varumärke: {{ brand?.name }}</p>
  </ng-container>
  <ng-container *ngIf="additionalInfo" class="margin-bottom--4x">
    <p>
      Övrig info
      <span *ngIf="adminOrPlanner && hasCustomerCommentAlert" class="tab tab--small warning">Kommentar från kund</span>
    </p>
    <p class="customer-comment">&quot;{{ additionalInfo }}&quot;</p>
    <div *ngIf="adminOrPlanner && hasCustomerCommentAlert" class="relative">
      <input id="customerCommentReviewed" type="checkbox" class="checkbox" (change)="acknowledgeCustomerComment()" />
      <label for="customerCommentReviewed" class="checkbox">Markera som hanterad</label>
    </div>
  </ng-container>

  <div
    class="margin-left--none margin-right--none margin-bottom--2x shadow-z-1"
    *ngFor="let data of targetingData"
  >
    <targeting-summary
      [targeting]="data.targeting"
      [metaData]="data.meta"
      [part]="data.part"
      [expanded]="true"
    ></targeting-summary>
  </div>
</div>
